import React from 'react';

const DeleteModal = ({
  deleteModal,
  hideDeleteModal,
  confirmDeleteChat
}) => {
  if (!deleteModal.visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md mx-4 shadow-2xl">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
          Delete chat?
        </h2>
        
        <p className="text-gray-700 dark:text-gray-300 mb-2">
          This will permanently delete <span className="font-semibold text-gray-900 dark:text-white">{deleteModal.chatTopic}</span>.
        </p>
        
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-6">
          If you want to keep it, you can archive it instead.
        </p>
        
        <div className="flex gap-3 justify-end">
          <button
            onClick={hideDeleteModal}
            className="px-6 py-2 rounded-full border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={confirmDeleteChat}
            className="px-6 py-2 rounded-full bg-red-500 hover:bg-red-600 text-white transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;